import { TimeValidityApiModel } from './time-validity.api-model';
import { type IChannelApiModel } from './channel.api-model';
import type { ITicketSuggestion } from '../../../../models/ticket-suggestion.model';
import type { TravellerCategory } from '../../../../models/traveller-category.enum';
import type { TimeLimitation } from '../../../../models/time-limitation.enum';
import type { ProductInstanceType } from '../../../../models/product-instance-type.enum';

export class TicketSuggestionApiModel {
  public static mapToBusinessModel(apiModel: TicketSuggestionApiModel): ITicketSuggestion {
    return {
      productId: apiModel.productId,
      productName: apiModel.productName,
      productType: apiModel.productType,
      travellerCategory: apiModel.travellerCategory,
      timeLimitation: apiModel.timeLimitation,
      priceInSek: apiModel.priceInSek,
      timeValidity: apiModel.timeValidity ? TimeValidityApiModel.mapToBusinessModel(apiModel.timeValidity) : undefined,
      saleChannels: apiModel.saleChannels,
      productInstanceType: apiModel.productInstanceType,
    };
  }

  public productId!: number;
  public productName!: string;
  public productType!: number;
  public travellerCategory!: TravellerCategory;
  public timeLimitation!: TimeLimitation;
  public priceInSek!: number;
  public timeValidity!: TimeValidityApiModel;
  public saleChannels!: IChannelApiModel[];
  public productInstanceType!: ProductInstanceType;
}
